import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="py-12 px-4" data-id="element-256">
      <div className="max-w-3xl mx-auto bg-[#E74C3C]/10 border border-[#E74C3C]/30 rounded-2xl p-8 text-center backdrop-blur-sm" data-id="element-257">
        <div className="flex justify-center mb-4" data-id="element-258">
          <AlertTriangle className="w-12 h-12 text-[#E74C3C]" data-id="element-259" />
        </div>

        <div className="text-3xl md:text-4xl font-mono font-bold text-white mb-6 bg-[#E74C3C] inline-block px-6 py-2 rounded-lg shadow-lg" data-id="element-260">
          <CountdownTimer data-id="element-261" />
        </div>

        <h3 className="text-2xl font-bold text-white mb-4" data-id="element-262">
          ⚠️ Esta oferta con los 4 bonos gratis es solo por hoy
        </h3>

        <p className="text-lg text-gray-300 mb-2" data-id="element-263">
          Cuando el contador llegue a cero, los bonos dejan de estar incluidos y
          el precio vuelve a $30.990.
        </p>

        <p className="text-lg text-gray-300 font-medium" data-id="element-264">
          No hay extensión. No hay "mañana sigue". El contador es real.
        </p>
      </div>
    </section>;
}